import { Layers } from "lucide-react";
import { SECTION_COLORS, fmtTime } from "@/lib/music";
import { AiBadge } from "@/components/Badges";

export default function StructureTimeline({ sectionsData, currentTime, onSeek }) {
  const sections = sectionsData?.sections || [];
  if (!sections.length) {
    return (
      <div className="rounded-xl border border-[#222A38] bg-[#131822] p-8 text-center text-sm text-slate-500">
        <Layers className="mx-auto mb-2 text-slate-600" size={22} />
        Song structure detection was not run for this song.
      </div>
    );
  }
  const activeIdx = sections.findIndex((s) => currentTime >= s.start && currentTime < s.end);
  return (
    <div className="rounded-xl border border-[#222A38] bg-[#131822] p-4">
      <div className="mb-3 flex items-center gap-2">
        <h3 className="font-display text-base font-bold text-white">Song Structure</h3>
        <AiBadge />
      </div>
      <div className="space-y-2">
        {sections.map((s, i) => (
          <button
            key={`${s.name}-${s.start}`}
            data-testid={`section-${i}`}
            onClick={() => onSeek(s.start)}
            className={`flex w-full items-center gap-3 rounded-lg border p-3 text-left transition-all ${
              i === activeIdx ? "border-cyan-400/50 bg-cyan-500/5" : "border-[#222A38] bg-[#0B0E14] hover:border-[#3A4659]"
            }`}
          >
            <span className="h-8 w-1.5 rounded-full" style={{ backgroundColor: SECTION_COLORS[s.name] || "#94A3B8" }} />
            <span className="flex-1 font-semibold text-white">{s.name}</span>
            <span className="font-mono-sw text-xs text-slate-500">{fmtTime(s.start)} – {fmtTime(s.end)}</span>
            {i === activeIdx && <span className="h-2 w-2 rounded-full bg-cyan-400 shadow-[0_0_8px_rgba(6,182,212,0.6)]" />}
          </button>
        ))}
      </div>
    </div>
  );
}
